import { Box, Container, Stack } from "@mui/material";
import { retrieveTopUsers } from "./selector";
import { createSelector } from "@reduxjs/toolkit";
import { serverApi } from "../../../lib/config";
import { useSelector } from "react-redux";
import { Member } from "../../../lib/types/member";

const topUsersRetriever = createSelector(retrieveTopUsers, (topUsers) => ({
  topUsers,
}));

export default function ActiveUsers() {
  const { topUsers } = useSelector(topUsersRetriever);

  const hideBrokenImage = (event: React.SyntheticEvent<HTMLImageElement>) => {
    event.currentTarget.src = "/icons/default-user.svg";
  };

  return (
    <div className={"active-users-frame"}>
      <Container>
        <Stack className={"main"}>
          <Stack className={"section-heading compact"}>
            <span className={"section-kicker"}>Community</span>
            <Box className={"category-title"}>Active Readers</Box>
          </Stack>

          <div className={"reader-club"}>
            <div className={"reader-club-intro"}>
              <span>Reader club</span>
              <h3>People who keep the shelves alive.</h3>
              <p>
                Meet active readers discovering books, building wishlists and
                sharing their next favorite title.
              </p>
              <div className={"reader-club-stats"}>
                <strong>{topUsers.length || 0}</strong>
                <small>active readers</small>
              </div>
            </div>

            <Stack className={"cards-frame reader-row"}>
            {topUsers.length !== 0 ? (
              topUsers.map((member: Member, index: number) => {
                const imagePath = member.memberImage
                  ? `${serverApi}/${member.memberImage}`
                  : "/icons/default-user.svg";
                return (
                  <Stack className={"reader-card"} key={member._id}>
                    <span className={"reader-rank"}>#{index + 1}</span>
                    <div className={"reader-avatar"}>
                      <img
                        src={imagePath}
                        alt=""
                        onError={hideBrokenImage}
                      />
                    </div>
                    <strong>{member.memberNick}</strong>
                    <span>Book lover</span>
                  </Stack>
                );
              })
            ) : (
              <Box className="no-data">No active readers yet.</Box>
            )}
            </Stack>
          </div>
        </Stack>
      </Container>
    </div>
  );
}
